// HealthLabs cart context bridge 2.0.1. Generated; explicit install required.
(function () {
"use strict";
// Reviewed producer/store pairs. Never accept a caller-supplied collection URL or a fallback shop.
function trackingPublicApi({ instanceId, shop, publicApi }) {
  const slm = 'https://smanageapi.com/api/public/domain-tracking/v1';
  const hlm = 'https://hlmapi.eu/api/public/domain-tracking/v1';
  const pairs = {
    '20:my-healthlabspharm-com.myshopify.com': slm,
    '31:health-labs-shop.myshopify.com': slm,
    '2:healthlabs-pharm.myshopify.com': slm,
    '5:ru-healthlabs-pharm.myshopify.com': slm,
    '6:bg-healthlabs-pharm.myshopify.com': slm,
    '22:th-healthlabspharm-com.myshopify.com': slm,
    '8:onebrandska.myshopify.com': hlm
  };
  const expected = pairs[instanceId + ':' + shop];
  if (!expected || (publicApi !== undefined && publicApi !== expected)) throw new Error('Unreviewed tracking producer/store pair');
  return expected;
}


// Opt-in storefront bridge. A dtb1 token is an unverified proposal, never routing authority.
const CART_BRIDGE_VERSION = '2.0.1';
const CART_CONTEXT_ATTRIBUTE = 'hlx_domain_tracking_ctx';
const TOKEN = /^dtb1\.[a-f0-9]{64}$/;
const HOST = /^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/;
const CONSENT_KEYS = ['ad_storage', 'analytics_storage', 'ad_user_data', 'ad_personalization'];
const EVENTS = new Set(['page_view', 'view_item', 'add_to_cart', 'begin_checkout', 'add_shipping_info',
  'add_payment_info', 'purchase', 'view_item_list', 'search', 'view_cart', 'remove_from_cart',
  'checkout_contact_info_submitted', 'checkout_address_info_submitted']);

function purposePolicy(cfg) {
  const validRequired = value => Array.isArray(value) && value.length <= 4 &&
    new Set(value).size === value.length && value.every(key => CONSENT_KEYS.includes(key));
  const policies = cfg.destinationPolicies;
  const legacy = cfg.consent?.required === undefined ? [] : cfg.consent.required;
  if (policies != null && (policies.version !== 1 ||
      !['ads', 'ga4'].every(kind => validRequired(policies[kind]?.requiredConsent)))) return null;
  if (policies == null && !validRequired(legacy)) return null;
  const required = Object.fromEntries(['ads', 'ga4'].map(kind =>
    [kind, [...new Set(policies == null ? legacy : policies[kind].requiredConsent)].sort()]));
  if (cfg.measurementMode === 'shadow') {
    const purposes = cfg.shadow?.purposes, hints = cfg.shadow?.requiredConsentByDestination;
    // v2 exposes only bounded purpose metadata, never IDs/labels or measurement permission.
    if (purposes !== undefined || hints !== undefined) {
      if (!['ads', 'ga4'].every(kind => typeof purposes?.[kind] === 'boolean' && validRequired(hints?.[kind]))) return null;
      return { ads: purposes.ads, ga4: purposes.ga4, contractVersion: 1,
        required: Object.fromEntries(['ads', 'ga4'].map(kind => [kind, [...new Set(hints[kind])].sort()])) };
    }
    // Older redacted responses have no analytics authority; preserve their marketing diagnostic path.
    return { ads: true, ga4: false, required, contractVersion: policies == null ? 0 : 1 };
  }
  if (cfg.sendAllowed !== true || !cfg.events || typeof cfg.events !== 'object') return null;
  let ads = false, ga4 = false;
  for (const [name, event] of Object.entries(cfg.events)) {
    if (!EVENTS.has(name) || event?.enabled !== true || event.eventOwner !== 'custom_pixel') continue;
    const value = event.adsValue || event.value || cfg.value;
    const adsValueValid = ['transaction', 'none'].includes(value?.source) ||
      (value?.source === 'constant' && typeof value.constantAmount === 'number' &&
        Number.isFinite(value.constantAmount) && value.constantAmount >= 0 && /^[A-Z]{3}$/.test(value.currency || ''));
    if (adsValueValid && event.destinations?.ads === true && /^AW-\d{5,20}$/.test(cfg.ads?.conversionId || '') &&
        /^[A-Za-z0-9_-]{1,128}$/.test(event.adsLabel || '')) ads = true;
    if (event.destinations?.ga4 === true && /^G-[A-Z0-9]{4,20}$/.test(cfg.ga4?.measurementId || '')) ga4 = true;
  }
  return { ads, ga4, required, contractVersion: policies == null ? 0 : 1 };
}
function purposeAllowed(policy, consent) {
  return !!policy && ((policy.ads && consent.ad_storage && policy.required.ads.every(key => consent[key] === true)) ||
    (policy.ga4 && consent.analytics_storage && policy.required.ga4.every(key => consent[key] === true)));
}

function compatible(required = '1') {
  if (!/^\d+(?:\.\d+){0,2}$/.test(String(required))) return false;
  const a = CART_BRIDGE_VERSION.split('.').map(Number), b = String(required).split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    if ((b[i] || 0) !== (a[i] || 0)) return (b[i] || 0) < (a[i] || 0);
  }
  return true;
}

function publicCartToken(token) {
  // Shopify can append a private cart key. Only the public identity is needed by SLM.
  if (typeof token !== 'string') return '';
  const value = token.split('?')[0];
  return /^[A-Za-z0-9_-]{8,256}$/.test(value) ? value : '';
}

function createCartContextBridge(env, options) {
  const { instanceId, shop } = options;
  if (!Number.isInteger(instanceId) || instanceId < 1 ||
      !/^[a-z0-9-]+\.myshopify\.com$/.test(shop || '')) throw new Error('Invalid instance/shop');
  const publicApi = trackingPublicApi(options);
  const now = env.now || Date.now;
  const storageKey = 'hlx:domain-cart-bridge:v1:' + instanceId + ':' + shop;
  let owned = null, erasure = null, working = null, rerun = false, stopped = false, revision = 0;
  let lastConsent = null, lastPolicy = null, nextIssueAt = 0;

  function context() {
    const location = env.location(), shopify = env.shopify();
    const host = location?.host;
    const root = shopify?.routes?.root;
    if (location?.protocol !== 'https:' || !HOST.test(host || '') || shopify?.shop !== shop ||
        !/^\/(?:[A-Za-z0-9-]+\/)*$/.test(root || '')) return null;
    return { host, root };
  }
  function consentState() {
    const read = method => {
      try { return env.shopify()?.customerPrivacy?.[method]?.() === true; }
      catch { return false; }
    };
    const marketing = read('marketingAllowed'), sale = read('saleOfDataAllowed');
    return { ad_storage: marketing, analytics_storage: read('analyticsProcessingAllowed'),
      ad_user_data: marketing && sale, ad_personalization: marketing && sale };
  }
  function possible(consent) { return consent.ad_storage || consent.analytics_storage; }
  function observeConsent() {
    const current = consentState();
    if (!lastConsent || CONSENT_KEYS.some(key => current[key] !== lastConsent[key])) {
      revision++;
      lastConsent = current;
    }
    return current;
  }
  function gate(epoch, ctx, cfg = null) {
    const current = context(), consent = observeConsent();
    return !stopped && (cfg ? purposeAllowed(cfg.policy, consent) : possible(consent)) && revision === epoch &&
      current?.host === ctx.host && current?.root === ctx.root;
  }
  function validRecord(record, ctx) {
    return record?.schemaVersion === 1 && record.instanceId === instanceId && record.shop === shop &&
      record.host === ctx.host && TOKEN.test(record.token || '') &&
      (record.erasurePending === undefined || record.erasurePending === true) &&
      /^[a-f0-9]{64}$/.test(record.cartHash || '') && Number.isInteger(record.profileId) && record.profileId > 0 &&
      Number.isInteger(record.configVersion) && record.configVersion > 0 && Number.isFinite(record.expiresAt);
  }
  function loadOwned(ctx) {
    if (validRecord(owned, ctx)) return owned;
    try {
      const saved = JSON.parse(env.storage?.getItem(storageKey) || 'null');
      return validRecord(saved, ctx) ? saved : null;
    } catch { return null; }
  }
  function sameRecord(a, b) {
    return a?.instanceId === b?.instanceId && a?.shop === b?.shop && a?.host === b?.host &&
      a?.token === b?.token && a?.cartHash === b?.cartHash;
  }
  function forget(record) {
    if (sameRecord(owned, record)) owned = null;
    try {
      const saved = JSON.parse(env.storage?.getItem(storageKey) || 'null');
      if (sameRecord(saved, record)) env.storage?.removeItem(storageKey);
    } catch { /* Memory-only fallback. */ }
  }
  function markErasure(record) {
    erasure = { ...record, erasurePending: true };
    owned = null;
    try {
      const saved = JSON.parse(env.storage?.getItem(storageKey) || 'null');
      if (!saved || sameRecord(saved, record)) env.storage?.setItem(storageKey, JSON.stringify(erasure));
    } catch { /* Keep cleanup-only ownership in memory if storage is unavailable. */ }
  }
  function remember(record) {
    owned = record;
    try { env.storage?.setItem(storageKey, JSON.stringify(record)); } catch { /* Memory-only fallback. */ }
  }
  async function hash(token) {
    if (!env.crypto?.subtle) throw new Error('hash_unavailable');
    const bytes = await env.crypto.subtle.digest('SHA-256', new TextEncoder().encode(token));
    return Array.from(new Uint8Array(bytes), b => b.toString(16).padStart(2, '0')).join('');
  }
  async function request(url, body = null, cart = false) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await env.fetch(url, {
        method: body ? 'POST' : 'GET', credentials: cart ? 'same-origin' : 'omit',
        cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer', signal: controller.signal,
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': cart
          ? 'application/json' : 'text/plain;charset=UTF-8' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      if (!response.ok) throw new Error('http_failure');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function validAttributes(attributes) {
    return !!attributes && typeof attributes === 'object' && !Array.isArray(attributes) &&
      (!Object.hasOwn(attributes, CART_CONTEXT_ATTRIBUTE) || typeof attributes[CART_CONTEXT_ATTRIBUTE] === 'string');
  }
  async function cart(ctx) {
    const body = await request(ctx.root + 'cart.js', null, true);
    const token = publicCartToken(body?.token);
    if (!token || !validAttributes(body.attributes)) throw new Error('cart_missing');
    // Drop cart contents, note, customer data and all unrelated attributes immediately.
    return { token, cartHash: await hash(token), attribute: body.attributes?.[CART_CONTEXT_ATTRIBUTE] || '' };
  }
  async function config(ctx) {
    const cfg = await request(publicApi + '?instanceId=' + instanceId + '&host=' +
      encodeURIComponent(ctx.host) + '&adapterVersion=' + CART_BRIDGE_VERSION);
    if (cfg?.schemaVersion !== 1 || cfg.instanceId !== instanceId || cfg.shop !== shop ||
        cfg.host !== ctx.host || cfg.profileStatus !== 'active' || !compatible(cfg.adapterMinVersion) ||
        !['shadow', 'live'].includes(cfg.measurementMode) || !Number.isInteger(cfg.profileId) || cfg.profileId < 1 ||
        !Number.isInteger(cfg.configVersion) || cfg.configVersion < 1) return null;
    // Keep purpose booleans/requirements in memory only; never retain account IDs, labels, event data or PII.
    const policy = purposePolicy(cfg);
    return { profileId: cfg.profileId, configVersion: cfg.configVersion, policy,
      gateHash: policy ? await hash(JSON.stringify(policy)) : '' };
  }
  async function update(ctx, value) {
    // Ajax attribute updates are per key. Never replay a stale snapshot of other writers' attributes.
    return request(ctx.root + 'cart/update.js', { attributes: { [CART_CONTEXT_ATTRIBUTE]: value } }, true);
  }
  async function cleanup(ctx, record) {
    if (!validRecord(record, ctx) || stopped || context()?.host !== ctx.host || context()?.root !== ctx.root)
      return 'cleanup_pending';
    const current = await cart(ctx);
    if (current.cartHash !== record.cartHash || current.attribute !== record.token) return 'cleanup_skipped';
    if (stopped || context()?.host !== ctx.host || context()?.root !== ctx.root) return 'cleanup_pending';
    const written = await update(ctx, '');
    const token = publicCartToken(written?.token);
    if (!token || !validAttributes(written.attributes) ||
        await hash(token) !== record.cartHash || written.attributes[CART_CONTEXT_ATTRIBUTE] === record.token)
      throw new Error('cleanup_unconfirmed');
    return 'cleaned';
  }
  async function eraseOwned(ctx, fallback) {
    // Reading the exact-host owned record is solely for erasure, never reuse or third-party requests.
    const record = validRecord(erasure, ctx) ? erasure : loadOwned(ctx);
    if (!record) return fallback;
    // Persist a cleanup-only tombstone before the first await. Navigation must not orphan the cart token.
    markErasure(record);
    const status = await cleanup(ctx, record);
    if (status !== 'cleanup_pending') { forget(record); erasure = null; }
    return status;
  }
  async function cancelled(ctx, cfg) {
    const consent = observeConsent();
    if (!possible(consent) || (cfg && !purposeAllowed(cfg.policy, consent)))
      await eraseOwned(ctx, 'cancelled');
    return 'cancelled';
  }
  async function cycle() {
    const ctx = context();
    if (stopped || !ctx) return 'unavailable';
    // Finish a failed withdrawal before any new grant can create/reuse tracking state.
    const pending = validRecord(erasure, ctx) || loadOwned(ctx)?.erasurePending === true;
    const cleanupStatus = pending ? await eraseOwned(ctx, 'consent_denied') : null;
    if (cleanupStatus === 'cleanup_pending') return cleanupStatus;
    const consent = observeConsent();
    if (!possible(consent)) return cleanupStatus || eraseOwned(ctx, 'consent_denied');
    // A known lost purpose can erase an owned token even if the subsequent public config fetch fails.
    if (lastPolicy?.host === ctx.host && !purposeAllowed(lastPolicy.policy, consent))
      await eraseOwned(ctx, 'consent_denied');
    if (stopped || !possible(observeConsent()) || context()?.host !== ctx.host || context()?.root !== ctx.root)
      return cancelled(ctx, null);
    const epoch = revision, cfg = await config(ctx);
    if (!gate(epoch, ctx)) return cancelled(ctx, cfg);
    if (!cfg) { lastPolicy = null; return eraseOwned(ctx, 'inactive'); }
    lastPolicy = { host: ctx.host, policy: cfg.policy };
    if (!purposeAllowed(cfg.policy, observeConsent())) return eraseOwned(ctx, 'consent_denied');
    const initial = await cart(ctx);
    if (!gate(epoch, ctx, cfg)) return cancelled(ctx, cfg);
    const prior = loadOwned(ctx);
    const ownsCurrent = prior && prior.cartHash === initial.cartHash && prior.token === initial.attribute;
    // A token written by another tab/domain/instance (or with lost ownership metadata) is not ours to replace.
    if (initial.attribute && !ownsCurrent) return 'context_unowned';
    if (ownsCurrent && prior.expiresAt > now() + 60000 &&
        prior.profileId === cfg.profileId && prior.configVersion === cfg.configVersion &&
        prior.gateHash === cfg.gateHash && prior.storefrontRoot === ctx.root) {
      owned = prior; return 'reused';
    }
    if (now() < nextIssueAt) return 'throttled';
    nextIssueAt = now() + 15000;
    const issued = await request(publicApi + '/context/issue', {
      instanceId, host: ctx.host, cartToken: initial.token, storefrontRoot: ctx.root, adapterVersion: CART_BRIDGE_VERSION
    });
    if (!gate(epoch, ctx, cfg)) return cancelled(ctx, cfg);
    if (issued?.success !== true || issued.verified !== false || issued.sendAllowed !== false ||
        issued.reason !== 'binding_pending' || issued.attributeKey !== CART_CONTEXT_ATTRIBUTE ||
        !TOKEN.test(issued.token || '') || !Number.isInteger(issued.expiresInSeconds) ||
        issued.expiresInSeconds < 120 || issued.expiresInSeconds > 604800) return 'invalid_proposal';
    // Issue currently does not echo its pinned version. Re-read identity and purposes before accepting it.
    const refreshed = await config(ctx);
    if (!gate(epoch, ctx, cfg)) return cancelled(ctx, cfg);
    if (!refreshed || !purposeAllowed(refreshed.policy, observeConsent())) {
      lastPolicy = refreshed ? { host: ctx.host, policy: refreshed.policy } : null;
      await eraseOwned(ctx, 'config_changed');
      return 'config_changed';
    }
    if (refreshed.profileId !== cfg.profileId || refreshed.configVersion !== cfg.configVersion ||
        JSON.stringify(refreshed.policy) !== JSON.stringify(cfg.policy)) return 'config_changed';
    const current = await cart(ctx);
    if (!gate(epoch, ctx, cfg)) return cancelled(ctx, cfg);
    if (current.cartHash !== initial.cartHash) return 'cart_changed';
    if (current.attribute !== initial.attribute) return 'context_changed';
    const record = { schemaVersion: 1, instanceId, shop, host: ctx.host,
      profileId: cfg.profileId, configVersion: cfg.configVersion,
      gateHash: cfg.gateHash, storefrontRoot: ctx.root,
      cartHash: current.cartHash, token: issued.token,
      expiresAt: now() + (issued.expiresInSeconds - 60) * 1000 };
    // Persist intended ownership before an ambiguous POST so a later withdrawal can erase it.
    remember(record);
    const written = await update(ctx, issued.token);
    if (!gate(epoch, ctx, cfg)) return cancelled(ctx, cfg);
    const actualToken = publicCartToken(written?.token);
    const actualHash = actualToken ? await hash(actualToken) : '';
    if (!gate(epoch, ctx, cfg)) return cancelled(ctx, cfg);
    if (!actualToken || actualHash !== record.cartHash) return 'cart_changed';
    if (written.attributes?.[CART_CONTEXT_ATTRIBUTE] !== record.token) return 'write_unconfirmed';
    return 'prepared';
  }
  function sync() {
    const consent = observeConsent(); // Invalidate an in-flight prepare immediately on a consent transition.
    const ctx = context();
    // Record withdrawal synchronously even if a previous prepare/POST is still awaiting its response.
    if (!stopped && ctx && (!possible(consent) || (lastPolicy?.host === ctx.host && !purposeAllowed(lastPolicy.policy, consent)))) {
      const record = validRecord(erasure, ctx) ? erasure : loadOwned(ctx);
      if (record) markErasure(record);
    }
    if (working) { rerun = true; return working; }
    working = (async () => {
      let status;
      do {
        rerun = false;
        try { status = await cycle(); }
        catch { status = 'unavailable'; } // Fail quietly; never delay or cancel checkout.
        if (!stopped && !possible(observeConsent()) && owned) rerun = true;
      } while (rerun && !stopped);
      return { status, verified: false };
    })().finally(() => { working = null; });
    return working;
  }
  return Object.freeze({ sync, stop() { stopped = true; revision++; } });
}

// Explicit installation only. No intercepting fetch/XHR, forms, clicks, navigation or native pixel events.
function installCartContextBridge(window, document, options) {
  if (window.__HLX_CART_CONTEXT_BRIDGE) return window.__HLX_CART_CONTEXT_BRIDGE;
  let storage;
  try { storage = window.sessionStorage; } catch { /* Memory-only operation. */ }
  const bridge = createCartContextBridge({ location: () => window.location, shopify: () => window.Shopify,
    fetch: window.fetch.bind(window), crypto: window.crypto, storage }, options);
  const sync = () => { void bridge.sync(); };
  const visible = () => { if (document.visibilityState === 'visible') sync(); };
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('visibilitychange', visible);
  window.addEventListener('pageshow', sync);
  const timer = window.setInterval(visible, 15000);
  const installed = Object.freeze({ sync: bridge.sync, stop() {
    bridge.stop(); window.clearInterval(timer);
    document.removeEventListener('visitorConsentCollected', sync);
    document.removeEventListener('visibilitychange', visible);
    window.removeEventListener('pageshow', sync);
  } });
  window.__HLX_CART_CONTEXT_BRIDGE = installed;
  sync();
  return installed;
}

const OPTIONS = Object.freeze({"instanceId":8,"shop":"onebrandska.myshopify.com","publicApi":"https://hlmapi.eu/api/public/domain-tracking/v1"});
window.HLXInstallCartContextBridge = function () {
  return installCartContextBridge(window, document, OPTIONS);
};
})();
